import { Form, Input, InputNumber, Radio, Select } from "antd"
import React, { useEffect, useState } from "react"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import { CONFIG_QUILL_FORMAT, CONFIG_QUILL_MODULE } from "~/constants/constants"
import { t } from "~/languages/i18n"
import { AttributesRecruitment, RecruitmentFormProps } from "~/types/types"

const RecruitmentForm: React.FC<RecruitmentFormProps> = ({ form, onFinishFailed, quillValue, onFinish }) => {
  const quillRef = React.useRef<ReactQuill>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)

  const handleSubmit = () => {
    const editorContent = quillRef.current?.getEditor().root.innerHTML || ""
    form.setFieldsValue({ Content: editorContent })
    onFinish(form.getFieldsValue())
  }

  useEffect(() => {
    if (quillValue && quillRef.current) {
      const editor = quillRef.current.getEditor()
      editor.root.innerHTML = quillValue
    }
  }, [quillValue])

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <Form
      form={form}
      className="flex flex-col w-[77%] "
      name="recruitmentForm"
      initialValues={{ remember: true }}
      onFinish={handleSubmit}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      layout="vertical"
    >
      <Form.Item<AttributesRecruitment>
        name="Title"
        rules={[{ required: true, message: t("Please input the job title!") }]}
        className="mt-4"
      >
        <Input placeholder={t("Job Title")} className="text-xl custom-input" />
      </Form.Item>

      <div className="flex flex-row justify-between">
        <Form.Item<AttributesRecruitment>
          name="Rank"
          rules={[{ required: true, message: t("Please input the job rank!") }]}
          label={t("Rank")}
        >
          <Select
            placeholder={t("Job Rank")}
            options={[
              { value: "Nhân viên", label: t("Manager") },
              { value: "Quản lý", label: t("Staff") },
            ]}
          />
        </Form.Item>

        <Form.Item<AttributesRecruitment>
          name="Quantity"
          rules={[{ required: true, message: t("Please input the number of positions!") }]}
          label={t("Quantity")}
        >
          <InputNumber min={1} placeholder={t("Number of Positions")} />
        </Form.Item>
        <Form.Item<AttributesRecruitment>
          name="Form"
          rules={[{ required: true, message: t("Please enter the work type!") }]}
          label={t("Form")}
        >
          <Radio.Group>
            <Radio value={true}>{t("Full Time")}</Radio>
            <Radio value={false}>{t("Part Time")}</Radio>
          </Radio.Group>
        </Form.Item>
      </div>

      <Form.Item<AttributesRecruitment> name="Content" label={t("Job Description")}>
        <div
          style={{
            height: "500px",
            overflowY: "auto",
            position: "relative",
            borderRight: "solid 1px #d9d9d9",
            borderRadius: "7px",
          }}
        >
          <ReactQuill
            ref={quillRef}
            className="h-[456px]"
            modules={CONFIG_QUILL_MODULE}
            formats={CONFIG_QUILL_FORMAT}
          />
        </div>
      </Form.Item>
    </Form>
  )
}

export default RecruitmentForm
